/**
 * Collection Grid Custom - Mobile and Desktop Column Switcher
 */
class CollectionGridController {
  constructor() {
    this.gridContainer = document.querySelector(".collection-products-grid");
    this.mobileControlsContainer = document.querySelector(
      ".facets-controls--mobile",
    );
    this.desktopControlsContainer = document.querySelector(
      ".facets-controls--desktop",
    );
    this.gridButtons = document.querySelectorAll(
      ".grid-layout-selector__button",
    );
    this.currentColumns = 2; // Default to 2 columns

    this.init();
  }

  init() {
    if (!this.gridContainer) {
      console.warn("Collection grid container not found");
      return;
    }

    if (!this.mobileControlsContainer && !this.desktopControlsContainer) {
      console.warn("No collection grid controls found");
      return;
    }

    this.setupEventListeners();
    this.setInitialState();
  }

  setupEventListeners() {
    this.gridButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const columns = parseInt(button.dataset.columns);
        this.switchGrid(columns);
      });
    });

    // Handle window resize for responsive behavior
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.handleResize();
      }, 250);
    });
  }

  setInitialState() {
    // Set default active state for both mobile and desktop buttons
    const mobileDefaultButton = document.querySelector(
      '.facets-controls--mobile .grid-layout-selector__button[data-columns="2"]',
    );
    const desktopDefaultButton = document.querySelector(
      '.facets-controls--desktop .grid-layout-selector__button[data-columns="4"]',
    );

    if (mobileDefaultButton) {
      this.updateActiveButton(mobileDefaultButton);
    }

    if (desktopDefaultButton) {
      this.updateActiveButton(desktopDefaultButton);
    }

    // Set default columns based on screen size
    const isDesktop = window.innerWidth >= 990;
    this.currentColumns = isDesktop ? 4 : 2;

    // Apply initial grid classes
    this.updateGridClasses(this.currentColumns);
  }

  switchGrid(columns) {
    if (columns === this.currentColumns) return;

    this.currentColumns = columns;
    this.updateGridClasses(columns);

    // Update active state for both mobile and desktop buttons
    const mobileButton = document.querySelector(
      `.facets-controls--mobile [data-columns="${columns}"]`,
    );
    const desktopButton = document.querySelector(
      `.facets-controls--desktop [data-columns="${columns}"]`,
    );

    if (mobileButton) {
      this.updateActiveButton(mobileButton);
    }

    if (desktopButton) {
      this.updateActiveButton(desktopButton);
    }

    // Optional: Store user preference
    this.storeUserPreference(columns);

    // Animation refresh disabled
  }

  updateGridClasses(columns) {
    if (!this.gridContainer) return;

    // Remove all column classes (both mobile and desktop)
    this.gridContainer.classList.remove(
      "cpg-mobile-1",
      "cpg-mobile-2",
      "cpg-mobile-3",
      "cpg-desktop-1",
      "cpg-desktop-2",
      "cpg-desktop-3",
      "cpg-desktop-4",
      "cpg-desktop-5",
      "cpg-desktop-6",
    );

    // Add the appropriate column class based on current screen size
    const isDesktop = window.innerWidth >= 990;
    const prefix = isDesktop ? "cpg-desktop" : "cpg-mobile";
    this.gridContainer.classList.add(`${prefix}-${columns}`);
  }

  updateActiveButton(activeButton) {
    if (!activeButton) return;

    // Get the container to only update buttons within the same container
    const container = activeButton.closest(
      ".facets-controls--mobile, .facets-controls--desktop",
    );
    const containerButtons = container
      ? container.querySelectorAll(".grid-layout-selector__button")
      : [];

    // Remove active state from all buttons in the same container
    containerButtons.forEach((button) => {
      button.classList.remove("grid-layout-selector__button--active");
      // Update SVG fill for inactive state
      const rects = button.querySelectorAll("svg rect");
      rects.forEach((rect) => {
        rect.style.fill = "rgba(var(--color-foreground), 0.2)";
      });
    });

    // Add active state to selected button
    activeButton.classList.add("grid-layout-selector__button--active");

    // Update SVG fill for active state
    const activeRects = activeButton.querySelectorAll("svg rect");
    activeRects.forEach((rect) => {
      rect.style.fill = "rgb(var(--color-button))";
    });
  }

  // Animation methods disabled - no bouncy effects

  storeUserPreference(columns) {
    try {
      localStorage.setItem("collection-grid-columns", columns.toString());
    } catch (e) {
      console.warn("Could not store grid preference:", e);
    }
  }

  getUserPreference() {
    try {
      const stored = localStorage.getItem("collection-grid-columns");
      return stored ? parseInt(stored) : this.currentColumns;
    } catch (e) {
      console.warn("Could not retrieve grid preference:", e);
      return this.currentColumns;
    }
  }

  handleResize() {
    // Re-apply current grid state after resize
    // This will switch between mobile and desktop classes as needed
    this.updateGridClasses(this.currentColumns);
  }

  // Public method to programmatically change grid
  setColumns(columns) {
    if (columns >= 1 && columns <= 6) {
      this.switchGrid(columns);
    }
  }

  // Public method to get current column count
  getCurrentColumns() {
    return this.currentColumns;
  }
}

// Auto-initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  window.collectionGrid = new CollectionGridController();
});

// Also handle dynamic content loading (for AJAX)
document.addEventListener("shopify:section:load", () => {
  if (window.collectionGrid) {
    window.collectionGrid = new CollectionGridController();
  }
});
